const parse = require('./parse')
const prerelease = (version, options) => {
  const parsed = parse(version, options)
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
}
module.exports = prerelease



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/prerelease.js
// module id = 1925
// module chunks = 1